export default [
  {
    name: 'gamification',
    path: '/gamification',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Gamificação',
      icon: 'dvr',
      label: 'Gamificação',
      permission: ['gamification.setting', 'gamification.control']
    }
  }
]
